import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AuthState, User } from './types';

const initialState: AuthState = {
  currentUser: null,
  isLoadingProfile: false,
  isLoggingIn: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.currentUser = action.payload;
      state.isLoadingProfile = false;
    },
    clearUser: (state) => {
      state.currentUser = null;
      state.isLoadingProfile = false;
    },
    setLoadingProfile: (state, action: PayloadAction<boolean>) => {
      state.isLoadingProfile = action.payload;
    },
    setLoggingIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggingIn = action.payload;
    }
  }
});

// Selectors
export const getCurrentUser = (state: { auth: AuthState }) => state.auth.currentUser;
export const getIsLoadingProfile = (state: { auth: AuthState }) => state.auth.isLoadingProfile;
export const { setUser, clearUser, setLoadingProfile, setLoggingIn } = authSlice.actions;
export default authSlice.reducer;
